module.exports = __webpack_public_path__ + "static/media/expense.7cf8ecd0.png";